export default {
  loading: 'Loading...',
  poweredBy: 'Powered by ',
  allRightsReserved: 'All rights reserved - ',
  pageTitle: 'NoiseGrasp'
}
